export default __webpack_public_path__ + "static/media/551.0abf861c.png";